import { z } from 'zod/mini'

export const UserClassificationInfoRecord = z.object({
  key: z.string(),
  code: z.string(),
  value: z.string(),
  rank: z.nullish(z.number()),
  validStartDate: z.nullable(z.date()),
  validEndDate: z.nullable(z.date()),
  memo: z.optional(z.string()),
  status: z.nullish(z.enum(['使用中', '未使用', ''])),
  type: z.optional(z.string()),
  displayOrder: z.string(),
  isCreated: z.optional(z.boolean()),
  isDeleted: z.optional(z.boolean())
})

/** @typedef {import('zod/mini').infer<UserClassificationInfoRecord>} UserClassficationRecordType */

export const UserClassificationInfoRecordList = z.array(UserClassificationInfoRecord)

export const UserClassificationType = z.object({
  label: z.string(),
  code: z.string(),
  isInProgress: z.optional(z.boolean()),
  memo: z.optional(z.string()),
  itemCount: z.optional(z.number()),
  standardFormatColumnName: z.optional(z.string()),
  displayOrder: z.optional(z.number())
})

export const UserClassificationPageState = z.object({
  mainStore: z.record(z.string(), z.any()),
  userClassificationTypes: z.array(UserClassificationType),
  selectedUserClassificationType: z.string(),
  errors: z.object({
    client: z.array(z.string()),
    server: z.array(z.string()),
    byClassification: z.record(z.string(), z.array(z.string())),
    importWarnings: z.optional(z.record(z.string(), z.array(z.string()))),
    importValidationErrors: z.optional(
      z.record(
        z.string(),
        z.array(
          z.object({
            recordIndex: z.number(),
            field: z.string(),
            message: z.string()
          })
        )
      )
    ),
    recordValidationErrors: z.optional(z.record(z.string(), z.record(z.string(), z.array(z.string()))))
  }),
  userClassificationRecords: z.record(z.string(), UserClassificationInfoRecordList),
  initialClassificationRecords: z.optional(z.record(z.string(), UserClassificationInfoRecordList)),
  changeHistory: z.optional(z.array(z.any())),
  pendingUpdates: z.optional(z.record(z.string(), z.any())),
  updateStatus: z.optional(z.record(z.string(), z.string())),
  importedFlags: z.optional(z.record(z.string(), z.boolean()))
})

export const UserClassificationTypesResponseItem = z.object({
  label: z.string(),
  code: z.string().check(z.minLength(1)),
  memo: z.optional(z.string()),
  itemCount: z.optional(z.number()),
  standardFormatColumnName: z.optional(z.string()),
  displayOrder: z.optional(z.number())
})

export const UserClassificationTypesResponse = z.array(UserClassificationTypesResponseItem)

export const UserClassificationInfoRecordResponseItem = z.object({
  code: z.string(),
  value: z.string(),
  key: z.string(),
  valid_start_date: z.string(),
  valid_end_date: z.string(),
  status: z.string(),
  display_order: z.string(),
  rank: z.nullish(z.number()),
  memo: z.optional(z.string()),
  create_date_time: z.string(),
  type: z.string()
})

export const UserClassificationInfoRecordResponse = z.array(UserClassificationInfoRecordResponseItem)
